import InfoSource from './InfoSource';

export default InfoSource;
